import { UserManager } from "oidc-client-ts";
import { getOidcSettings } from "./oidcConfig";

let instance: UserManager | null = null;

export function getUserManager(): UserManager {
  if (!instance) instance = new UserManager(getOidcSettings());
  return instance;
}
